import type { Session } from '@heroiclabs/nakama-js';
import type { ApiAccount, ApiUpdateAccountRequest, Users } from '../types/nakama';
import { getClient } from './client';

/**
 * Fetch the current user's full account information.
 */
export async function getAccount(session: Session): Promise<ApiAccount> {
  const client = getClient();
  return client.getAccount(session);
}

/**
 * Update fields on the current user's account.
 */
export async function updateAccount(
  session: Session,
  request: ApiUpdateAccountRequest,
): Promise<boolean> {
  const client = getClient();
  return client.updateAccount(session, request);
}

/**
 * Fetch one or more users by ID or username.
 */
export async function getUsers(
  session: Session,
  ids?: string[],
  usernames?: string[],
): Promise<Users> {
  const client = getClient();
  return client.getUsers(session, ids, usernames);
}
